import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const investorProfilePiSurveyFields: FieldInterface[] = [
  {
    key: 'hasNoMore',
    originKey: 'has_no_more',
    type: FIELD_TYPES.boolean,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'version',
    originKey: 'version',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isOptional,
  },
  {
    key: 'step',
    originKey: 'step',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isOptional,
    isMultiple: true,
  },
]

const investorProfilePiSurveyRelations: RelationInterface[] = []

export { investorProfilePiSurveyFields, investorProfilePiSurveyRelations }
